import { type FC, type KeyboardEvent, useCallback } from "react";

import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

const SeeMoreElement = styled.div`
    cursor: pointer;

    margin-top: auto;
    padding-top: 8px;

    font-size: 12px;
    font-weight: 500;
    font-style: normal;
    line-height: 12px;
    color: ${Colors.Blue.V100};
`;

interface SeeMoreButtonProps {
    isActive: boolean;
    isVisible: boolean;
    onClick: () => void;
}

export const SeeMoreButton: FC<SeeMoreButtonProps> = ({ isActive, isVisible, onClick }) => {
    const onKeypressSeeMoreTrigger = useCallback(
        ({ nativeEvent }: KeyboardEvent<HTMLDivElement>) => {
            if (nativeEvent.key !== "Enter") {
                return;
            }
            onClick();
        },
        [onClick],
    );

    if (!isVisible) {
        return null;
    }

    const seeMoreText = isActive ? "See Less" : "See More";

    return (
        <SeeMoreElement role="button" tabIndex={0} onClick={onClick} onKeyPress={onKeypressSeeMoreTrigger}>
            {seeMoreText}
        </SeeMoreElement>
    );
};
